// src/utils/lazyWithRetry.js
const lazyWithRetry = (componentImport, name = 'chunk') => {
  // eslint-disable-line
  return new Promise((resolve, reject) => {
    const MAX_RETRIES = 1;
    const RETRY_DELAY_MS = 0; // 0 delay between retries because the main error we are trying to catch is the chunk load error from stale chunks
    const storageKey = `retry-${name}-refreshed`;

    // check if the window has already been refreshed for this chunk
    const hasRefreshed = JSON.parse(window.sessionStorage.getItem(storageKey) || 'false');

    const attemptImport = (retriesLeft) => {
      componentImport()
        .then((component) => {
          window.sessionStorage.setItem(storageKey, 'false'); // success so reset the refresh
          resolve(component);
        })
        .catch((error) => {
          const isChunkError =
            error.name === 'ChunkLoadError' ||
            (error.message &&
              (error.message.includes('Failed to fetch dynamically imported module') ||
                error.message.includes('error loading dynamically imported module') ||
                error.message.includes('Importing a module script failed') ||
                // Safari/iOS (WebKit) returns the SPA fallback index.html for a stale chunk URL
                error.message.includes('is not a valid JavaScript MIME type') ||
                error.message.includes('valid JS MIME type')));
          if (isChunkError) {
            if (retriesLeft > 0) {
              console.warn(`ChunkLoadError for ${name}, retrying... (${retriesLeft} attempts left)`);
              setTimeout(() => attemptImport(retriesLeft - 1), RETRY_DELAY_MS);
            } else if (!hasRefreshed) {
              console.error(`ChunkLoadError for ${name} after multiple retries. Refreshing page.`);
              window.sessionStorage.setItem(storageKey, 'true');
              window.location.reload();
            } else {
              console.error(`ChunkLoadError for ${name} after multiple retries and page refresh. Giving up.`);
              reject(error); // Propagate error to ErrorBoundary
            }
          } else {
            reject(error); // Not a chunk error, propagate
          }
        });
    };

    attemptImport(MAX_RETRIES);
  });
};

export default lazyWithRetry;
